import { render, staticRenderFns } from "./PFAdvanceSettings.vue?vue&type=template&id=f8a627c6&scoped=true"
import script from "./PFAdvanceSettings.vue?vue&type=script&lang=js"
export * from "./PFAdvanceSettings.vue?vue&type=script&lang=js"
import style0 from "./PFAdvanceSettings.vue?vue&type=style&index=0&id=f8a627c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a627c6",
  null
  
)

export default component.exports